import React, { useState } from "react";
import axios from "axios";
import { gtag_report_conversion } from "./gTagUtils";

const BannerForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Specific handling for phoneNumber field
    if (name === "mobile") {
      // Remove non-digit characters
      const cleanedValue = value.replace(/\D/g, "");

      // Ensure the cleaned value is exactly 10 digits
      if (cleanedValue.length <= 10) {
        setFormData({ ...formData, [name]: cleanedValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate phone number length
    if (formData.mobile.length !== 10) {
      alert("Phone number must be exactly 10 digits.");
      return;
    }

    try {
      // Replace with your actual backend endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/query`,
        formData
      );
      console.log(response.data);
      alert(
        "Query submitted successfully. Our Sales Executive will contact you soon."
      );
      setFormData({ name: "", city: "", mobile: "", message: "" }); // Reset form
      gtag_report_conversion();
    } catch (error) {
      console.error("Error submitting query:", error);
      alert("Failed to submit query");
    }
  };

  return (
    <section className="banner-form">
      <div className="banner-inner">
        <div className="banner-content">
          <h1>Trumac Healthcare</h1>
          <h2>PCD Pharma Franchise</h2>
          <p>
            Trumac Healthcare is a leading pcd pharma company in India. We are
            manufacturers and suppliers of finished pharma medicines since last
            17 years all over India. We have a wide range of product portfolio
            consisting of tablets, capsules, injectable, syrups, ointments, eye,
            ear and nasal drops. Our products are manufactured at one of the
            best art of state manufacturing facilities, which are WHO and GMP
            certified units.
          </p>
          <div className="product-info-banner">
            <span>
              <strong>3000+ Premium Products at Your Fingertips</strong>
            </span>
          </div>
        </div>
        <div className="query-form">
          <h3>PCD Pharma Query</h3>
          <p>(No Job Postings)</p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="city"
              placeholder="Your City"
              value={formData.city}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="mobile"
              placeholder="Your Phone Number"
              value={formData.mobile}
              onChange={handleChange}
              required
              pattern="\d{10}"
              title="Please enter exactly 10 digits."
              maxLength="10"
              minLength="10"
            />
            <textarea
              name="message"
              placeholder="Your Message (Optional)"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            <button type="submit">Submit Enquiry</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BannerForm;
